import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';

import ApIngestionContainer from '../../containers/apAutomation/ApIngestion';
import ResourceUploader from '../form/ResourceUploader';
import Button from '@material-ui/core/Button';
import Zoom from '@material-ui/core/Zoom';
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import Transition from './Transition';
import { DialogActions, Grid, IconButton } from '@material-ui/core';
import FMPText from '../pureForm/FMPText';
import FormComponent from '../FormComponent';
import FMPSectionHeader from '../ui/FMPSectionHeader';
import FMPSubmitButton from '../form/FMPSubmitButton';
import { post } from '../../modules/utility';
import FMPRailcarAutocomplete from '../pureForm/FMPRailcarAutocomplete';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 50px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		width: '95%',
		maxWidth: '95%',
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	greenCheckedIcon: {
		display: 'inline-block',
		width: 33,
		height: 33,
		backgroundImage: `url('${GreenChecked}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
		marginLeft: 5,
	},
	isSaving: {
		marginLeft: 20,
		fontSize: 16,
		color: '#1565C0',
	},
	savingSuccessful: {
		marginLeft: 20,
		fontSize: 16,
		color: '#2E7D32',
	},
	stationDeliveryRow: {
		display: 'flex',
		lineHeight: '1.5',
		alignItems: 'flex-end',
	},
	deliveryLabel: {
		paddingRight: '4px',
		fontWeight: 500,
		color: '#222',
		fontSize: '85%',
		//letterSpacing: '.1em',
		textTransform: 'uppercase',
	},
	deliveryContainer: {
		padding: 10,
		border: '1px solid #ddd',
		borderRadius: '5px',
		backgroundColor: '#f7f7f7',
	},
});

const USE_SAMPLE = false;

const sampleResource = {
	contentType: 'application/pdf',
	createdByUserId: 14,
	dateCreated: '2024-04-21T23:37:33Z',
	resourceId: 888888908,
	url: 'https://s3-us-west-2.amazonaws.com/fmp-dev-resources/2024321-64985-9EXTw.pdf',
};

class RailcarLinkageAddDialog extends FormComponent {
	constructor(props) {
		super(props);

		this.state = {
			formFieldError: {},
			isSaving: false,
			savingSuccessful: false,
			bolResource: undefined,
			fuelEntries: [{}],
		};
		if (USE_SAMPLE) {
			this.state.bolResource = sampleResource;
			this.state.bol = '1111';
			this.state.fuelEntries = [
				{
					netGallons: '222',
					grossGallons: '333',
				},
			];
		}
	}

	addAnotherFuelInput = (arrayName) => {
		// Go through and find the "next" one in the list to default
		const { railcarOptions, selectedRailcarId, selectedTerminalId } = this.props;
		let nextRailcarId = selectedRailcarId;

		const filteredOptions = _.filter(railcarOptions, { terminalId: selectedTerminalId });
		filteredOptions.forEach((railcarOption, i) => {
			if (railcarOption.value === selectedRailcarId) {
				if (filteredOptions[i + 1]) {
					nextRailcarId = filteredOptions[i + 1].value;
				}
			}
		});
		this.setState({
			[arrayName]: this.state[arrayName].concat([
				{
					railcarId: nextRailcarId,
				},
			]),
		});
	};

	handleOnUpload = () => {
		this.setState({ isUploading: true });
	};
	handleDataFileUpload = ({ resource }) => {
		this.setState({ isUploading: false, bolResource: resource });
	};

	componentDidMount() {
		if (this.props.selectedRailcarId) {
			this.setState({
				bol: undefined,
				fuelEntries: [
					{
						railcarId: this.props.selectedRailcarId,
						linkedRailcarId: this.props.selectedLinkedRailcarId,
					},
				],
			});
		}
	}

	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.selectedRailcarId !== prevProps.selectedRailcarId) {
			this.setState({
				bol: undefined,
				fuelEntries: [
					{
						railcarId: this.props.selectedRailcarId,
						linkedRailcarId: this.props.selectedLinkedRailcarId,
					},
				],
			});
		}
	}

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;
		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getInputProps = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.onChange,
			checked: this.getValue(path, false),
			md: 12,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	handleClose = () => {
		this.setState({
			isSaving: false,
			savingSuccessful: false,
			bolResource: undefined,
			fuelEntries: [{}],
		});
		this.props.onClose();
	};

	handleSave = () => {
		const {
			showErrors,
			selectedStationDelivery,
			selectedStationId,
			selectedTankNumber,
			onAfterSave,
		} = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!_.get(this.state, path)) {
				formFieldError[path] = `${label} is required`;
			}
		});
		const { bol, bolResource, fuelEntries } = this.state;
		fuelEntries.forEach((fuelEntry, i) => {
			const { netGallons, grossGallons } = fuelEntry;

			const net = _.isString(netGallons) ? parseInt(netGallons.replace(/,/g, ''), 10) : netGallons;
			if (!net || _.isNaN(net)) {
				formFieldError[`fuelEntries[${i}].netGallons`] = `Net should be a number`;
			} else {
				fuelEntry.netGallons = net;
			}

			if (grossGallons) {
				const gross = _.isString(grossGallons)
					? parseInt(grossGallons.replace(/,/g, ''), 10)
					: grossGallons;
				if (!gross || _.isNaN(gross)) {
					formFieldError[`fuelEntries[${i}].grossGallons`] = `Gross should be a number`;
				} else {
					fuelEntry.grossGallons = gross;
				}
			} else {
				delete fuelEntry.grossGallons;
			}
		});

		if (!bolResource) {
			formFieldError['bolResourceId'] = `A BOL pdf is required`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}
		const params = {
			bol,
			bolResourceId: bolResource.resourceId,
			stationId: selectedStationId,
			tankNumber: selectedTankNumber,
			stationDeliveryId: selectedStationDelivery.stationDeliveryId,
			fuelEntries,
		};

		this.setState({
			isSaving: true,
		});

		post({
			method: 'railcarToDeliveryMap.addMultiple',
			params,
			callback: (err, apiSearchResult) => {
				console.log(apiSearchResult);
				if (err) {
					this.setState({
						isSaving: false,
					});
					return showErrors([err]);
				}

				_.delay(() => {
					this.setState({
						isSaving: false,
						savingSuccessful: true,
					});
					if (onAfterSave) {
						onAfterSave();
					}
				}, 500);
			},
		});
	};

	render() {
		const {
			classes,
			fullScreen,
			open,
			selectedStationDelivery,
			railcarOptions,
			selectedTerminalId,
			selectedRailcarIsEmpty,
		} = this.props;
		const { isSaving, savingSuccessful, bolResource, isUploading } = this.state;

		const delivery = selectedStationDelivery;
		if (!delivery) {
			return (
				<Dialog
					fullScreen={fullScreen}
					maxWidth="md"
					open={open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
					classes={{ paper: classes.dialogPaper }}
				>
					<DialogTitle style={{ paddingBottom: 5 }}>Missing Delivery?</DialogTitle>
				</Dialog>
			);
		}

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth="md"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle style={{ paddingBottom: 5 }}>Link Delivery to BOL + Railcar</DialogTitle>
					<DialogContent>
						<Grid spacing={2} container>
							<Grid item xs={5}>
								<FMPSectionHeader label={'Delivery:'} isTop={true} />
								<div className={classes.deliveryContainer}>
									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Delivery Id:</div>
										<div className={classes.deliveryValue}>{delivery.stationDeliveryId}</div>
									</div>

									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Customer:</div>
										<div className={classes.deliveryValue}>{delivery.customerDisplay}</div>
									</div>
									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Delivery Window:</div>
										<div className={classes.deliveryValue}>{delivery.deliveryDateFormatted}</div>
									</div>
									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Scheduled Gallons:</div>
										<div className={classes.deliveryValue}>{delivery.scheduledGallons}</div>
									</div>
									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Carrier:</div>
										<div className={classes.deliveryValue}>{delivery.carrierDisplay}</div>
									</div>
									<div className={classes.stationDeliveryRow}>
										<div className={classes.deliveryLabel}>Loading #:</div>
										<div className={classes.deliveryValue}>{delivery.loadingNumber}</div>
									</div>
								</div>

								<Grid spacing={2} container>
									<Grid item xs={12}>
										<FMPSectionHeader label={'BOL Info:'} />
									</Grid>
									<FMPText {...this.setForm(`bol`, 'BOL #', true)} />
									<Grid item xs={12}>
										<FMPSectionHeader label={'Fuel Info:'} />
									</Grid>
									<Grid item xs={12}>
										{this.state.fuelEntries.map((fuelEntry, i) => {
											const isFirst = i === 0;
											const prefix = `fuelEntries[${i}]`;
											return (
												<div
													key={`fuelEntry_${i}`}
													style={{
														paddingLeft: 10,
														marginLeft: 10,
														borderLeft: '4px solid #eee',
														marginBottom: 20,
													}}
												>
													<div style={{ display: 'flex' }}>
														<Grid spacing={2} container>
															<FMPRailcarAutocomplete
																{...this.setForm(`${prefix}.railcarId`, 'Railcar', isFirst, null)}
																terminalId={selectedTerminalId}
																railcarOptions={railcarOptions}
																md={6}
															/>

															<FMPRailcarAutocomplete
																{...this.setForm(
																	`${prefix}.linkedRailcarId`,
																	'Linked Railcar',
																	false,
																	null
																)}
																terminalId={selectedTerminalId}
																railcarOptions={railcarOptions}
																filterOlderEmptyDates={!selectedRailcarIsEmpty}
																md={6}
															/>

															<FMPText
																{...this.setForm(`${prefix}.netGallons`, 'Net Gallons', isFirst)}
															/>
															<FMPText
																{...this.setForm(`${prefix}.grossGallons`, 'Gross Gallons', false)}
															/>
														</Grid>

														{!isFirst && (
															<Grid item xs={1}>
																<IconButton
																	color="primary"
																	className={classes.button}
																	onClick={() => this.removeInput('fuelEntries', i)}
																>
																	<DeleteIcon />
																</IconButton>
															</Grid>
														)}
													</div>
												</div>
											);
										})}
									</Grid>

									<Grid item xs={12}>
										<Button
											color="primary"
											variant="outlined"
											onClick={() => this.addAnotherFuelInput('fuelEntries')}
										>
											Add another fuel entry
										</Button>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={6}>
								{bolResource ? (
									<div className={classes.pageImage}>
										<object
											data={bolResource.url}
											style={{ height: '800px', width: '100%', maxWidth: '100%' }}
											type="application/pdf"
										>
											<a href={bolResource.url}>bol.pdf</a>
										</object>
									</div>
								) : (
									<ResourceUploader
										name={'bolResourceId'}
										label={''}
										onUpload={this.handleOnUpload}
										afterUpload={this.handleDataFileUpload}
									/>
								)}

								{isUploading && (
									<Zoom
										in={isSaving}
										style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
										mountOnEnter
										unmountOnExit
									>
										<div className={classes.isSaving}>
											<CircularProgress style={{ verticalAlign: 'middle' }} />
											<span style={{ paddingLeft: 10 }}>Saving...</span>
										</div>
									</Zoom>
								)}
							</Grid>
						</Grid>
					</DialogContent>

					<DialogActions>
						<Button onClick={this.handleClose}>Close</Button>

						<FMPSubmitButton
							onClick={this.handleSave}
							buttonText={'Save BOL to Delivery'}
							isDisabled={isSaving || savingSuccessful}
						/>
					</DialogActions>

					<div style={{ display: 'flex', alignItems: 'baseline' }}>
						<Zoom
							in={isSaving}
							style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
							mountOnEnter
							unmountOnExit
						>
							<div className={classes.isSaving}>
								<CircularProgress style={{ verticalAlign: 'middle' }} />
								<span style={{ paddingLeft: 10 }}>Saving...</span>
							</div>
						</Zoom>

						<Zoom
							in={savingSuccessful}
							style={{ transitionDelay: savingSuccessful ? '250ms' : '0ms' }}
						>
							<div className={classes.savingSuccessful}>
								<div className={classes.greenCheckedIcon} />
								<span style={{ paddingLeft: 10 }}>
									Save successful. Hit the close button or the escape key.
								</span>
							</div>
						</Zoom>
					</div>
				</div>
			</Dialog>
		);
	}
}

RailcarLinkageAddDialog.propTypes = {
	selectedStationDelivery: PropTypes.object,
	selectedStationId: PropTypes.number,
	selectedTankNumber: PropTypes.number,
	selectedRailcarId: PropTypes.number,
	selectedLinkedRailcarId: PropTypes.number,
	selectedRailcarIsEmpty: PropTypes.bool,
	selectedTerminalId: PropTypes.number,
	onAfterSave: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	fullScreen: PropTypes.bool.isRequired,
	railcarOptions: PropTypes.array,
	showErrors: PropTypes.func,
};

export default _.flow([withStyles(styles), withMobileDialog(), ApIngestionContainer])(
	RailcarLinkageAddDialog
);
